function Footer() {
  return (
    <div className="footer">
      <div className="signature">2022 Aimé Joseph ANDRIANOMENTSOA</div>
    </div>
  );
}
export default Footer;
